import { default as moment } from "moment";
import React from "react";

import QueryComponent from "core/api/QueryComponent";
import Class from "core/util/Class";
import { CalendarVariant, CalendarView, ICalendarEventAccessors, RangeData, Views } from "./Calendar.view";

/**
 * calendar view wrapped in a query component that lazy loads data as the visible range changes.
 *
 * @author chills
 */

interface IDataCalendarProps<T extends object, P> extends ICalendarEventAccessors<T> {
	entity: Class<T>;
	params?: P; // range start/end automatically included

	onSelectEvent?: (event: T) => void;

	rangeStartParam: string;
	rangeEndParam: string;

	variant?: CalendarVariant;
	viewKey: string;
}

interface IDataCalendarState {
	date?: Date;
	queryEnd?: Date;
	queryStart?: Date;
	view?: Views;
}

export default class DataCalendar<T extends object, P> extends React.Component<IDataCalendarProps<T, P>, IDataCalendarState> {

	public state: IDataCalendarState = { };

	public render() {

		const {
			entity,
			params = {},
			rangeStartParam,
			rangeEndParam,
			endAccessor,
			startAccessor,
			titleAccessor,
			onSelectEvent,
			variant,
			viewKey
		} = this.props;

		const start = this.state.queryStart ? moment(this.state.queryStart) : moment().startOf('month');
		const end = this.state.queryEnd ? moment(this.state.queryEnd) : moment().endOf('month');

		const args = {
			...params,
			[rangeStartParam]: start.startOf('day').toISOString(),
			[rangeEndParam]: end.endOf('day').toISOString()
		};

		return (
			<QueryComponent entity={entity} args={args} type="many">
				{
					({data}) => (
						<CalendarView
							date={this.state.date}
							events={Array.isArray(data) && data || []}
							startAccessor={startAccessor}
							endAccessor={endAccessor}
							titleAccessor={titleAccessor}
							onRangeChange={this.onRangeChange}
							onViewChange={this.onViewChange}
							onNavigate={this.onNavigate}
							onSelectEvent={onSelectEvent}
							view={this.state.view}
							variant={variant}
							viewKey={viewKey}
						/>
					)
				}
			</QueryComponent>
		);
	}

	private onRangeChange = (range: RangeData) => {
		const start = moment(Array.isArray(range) ? range[0] : range.start);
		const end = moment(Array.isArray(range) ? range[range.length - 1] : range.end);
		this.setState({queryStart: start.toDate(), queryEnd: end.toDate()});
	}

	private onViewChange = (view: Views) => this.setState({view});

	private onNavigate = (date: Date) => this.setState({date});
}



// WEBPACK FOOTER //
// ./src/common/views/calendar/DataCalendar.tsx